import PropTypes from 'prop-types';

import { buildStyledComponent } from 'decisiv-ui-utils';
import { Container } from 'styled-components-reactive-grid';

const modifierConfig = {
  bgBrandPrimary: ({ theme }) => `
    background: ${theme.colors.brand.primary};
    & > * {
      background: ${theme.colors.brand.primary};
    }
  `,
  bgBrandSecondary: ({ theme }) => `
    background: ${theme.colors.brand.secondary};
    & > * {
      background: ${theme.colors.brand.secondary};
    }
  `,
  bgChrome100: ({ theme }) => `
    background: ${theme.colors.base.chrome100};
    & > * {
      background: ${theme.colors.base.chrome100};
    }
  `,
};

const styles = '';

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      chrome100: PropTypes.string.isRequired,
    }).isRequired,
    brand: PropTypes.shape({
      primary: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent('Page', Container, styles, {
  modifierConfig,
  themePropTypes,
});



// WEBPACK FOOTER //
// ./src/blocks/Page/index.js